/* MAHA — sube el botón flotante de WhatsApp (.wa-float, ver sections/header.liquid
   + custom.css) cuando la barra sticky "Agregar" del PDP (.sticky-atc-bar, ver
   snippets/sticky-atc-bar.liquid) está visible, para que no se encimen en
   móvil/tablet (<1024px, la regla vive en custom.css). Mide la posición REAL de
   la barra con getBoundingClientRect en cada cambio -- nunca asume un alto fijo --
   así que se ajusta sola a cualquier ancho de pantalla, estilo (standard o
   minimalist) o contenido. No toca el botón "Agregar" ni su comportamiento: solo
   lee su posición ya renderizada. */
(function () {
  'use strict';
  if (window.__mahaWaFloatStickyOffsetInit) return;
  window.__mahaWaFloatStickyOffsetInit = true;

  function init() {
    var bar = document.querySelector('.sticky-atc-bar');
    var waFloat = document.querySelector('[data-wa-float]');
    if (!bar || !waFloat) return;

    function update() {
      var rect = bar.getBoundingClientRect();
      var fromBottom = Math.max(0, Math.round(window.innerHeight - rect.top));
      document.documentElement.style.setProperty('--wa-float-sticky-offset', fromBottom + 'px');
    }

    update();
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    bar.addEventListener('transitionend', update);

    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(bar);
    }
    if (window.MutationObserver) {
      new MutationObserver(update).observe(bar, { attributes: true, attributeFilter: ['class', 'style'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
